import React from 'react';

import withModal from '../../../../../../components/global/modal/withModal';
import GlobalWaldogramConfigurator from './GlobalWaldogramConfigurator';

export const GLOBAL_WALDOGRAM_CONFIGURATOR_MODAL =
  'GLOBAL_WALDOGRAM_CONFIGURATOR_MODAL';

const GlobalWaldogramConfiguratorModalComponent = ({
  actionProps: { photoId } = {},
  ...props
}) => <GlobalWaldogramConfigurator photoId={photoId} {...props} />;

const GlobalWaldogramConfiguratorModal = withModal(
  GlobalWaldogramConfiguratorModalComponent,
  {
    name: GLOBAL_WALDOGRAM_CONFIGURATOR_MODAL,
    size: 'lg',
    hideHeader: true,
    className: 'bulk-account-card-configurator-modal',
  },
);

export default GlobalWaldogramConfiguratorModal;
